import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { styled } from '@mui/system';
import Drawer from '@components/Drawer';
import ContactInfo from '@features/ContactInfo';
import Avatar from '@components/Avatar';
import EditContactModal from '@features/EditContactModal';
import InitConversation from '@features/InitConversation';
import ContactDeleteModal from '@features/ContactDeleteModal';
import ContactsMergeModal from '@features/ContactsMergeModal';
import { contactsActions } from '@actions';
import { getInitialsParts, getUserContacts, getFullName } from '@helpers/userName';
import { UserIcon } from 'assets/images/icons';

const StyledUserIcon = styled(UserIcon)({
    width: '16px !important',
    height: '16px !important',
    '& path': {
        fill: 'rgba(0, 0, 0, 0.38)',
        fillOpacity: 1,
    },
});

const ContactDrawer = ({ onInitConversationCallback, onDeleteCallback, onMergeCallback, onUpdateCallback }) => {
    const {
        contact,
        contactDrawerOpened,
        contactMergeModal,
        contactDeleteModal,
        contactEditModal,
        contactInitConversationModal,
    } = useSelector(state => state.contacts);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            onClose();
        };
    }, []);

    const onClose = () => {
        dispatch(
            contactsActions.setContactInitConversationModal({ open: false, contactId: null, companies: [], ctx: null }),
        );
        dispatch(contactsActions.setContactDrawer(false));
    };

    return (
        <>
            <Drawer
                anchor="right"
                open={contactDrawerOpened}
                onClose={onClose}
                title={
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: 20 }}>
                        <Avatar
                            size="medium"
                            fullName={getFullName(contact?.firstName, contact?.lastName)}
                            label={getInitialsParts(contact?.firstName, contact?.lastName)}
                            icon={<StyledUserIcon />}
                        />
                        <span style={{ marginLeft: 8, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {getUserContacts(
                                {
                                    firstName: contact?.firstName,
                                    lastName: contact?.lastName,
                                    phoneNumber: contact?.phoneNumber,
                                    email: contact?.email,
                                },
                                '-',
                            )}
                        </span>
                    </div>
                }
            >
                <ContactInfo contact={contact} />
            </Drawer>
            {contactEditModal.open ? (
                <EditContactModal modal={contactEditModal} onUpdateCallback={onUpdateCallback} />
            ) : null}
            {contactDeleteModal ? (
                <ContactDeleteModal onDeleteCallback={onDeleteCallback} open={contactDeleteModal} />
            ) : null}
            {contactMergeModal ? (
                <ContactsMergeModal onMergeCallback={onMergeCallback} open={contactMergeModal} />
            ) : null}
            {contactInitConversationModal.open ? (
                <InitConversation onInitConversationCallback={onInitConversationCallback} />
            ) : null}
        </>
    );
};

export default ContactDrawer;
